import AthleteService from "services/AthleteService";
import useMutation from "hooks/useMutation";

export interface UseAthleteSendEmailMutationProps {
  /** Only part of the mutation key: the athlete the request acts on comes from the trigger argument. */
  athleteId?: string;
}

export interface AthleteSendEmailArg {
  athleteId: string;
}

/**
 * @description Sends the pending invitation email again. The athlete's pending email address is
 * unchanged, so there is nothing to patch in the athletes store.
 */
function useAthleteSendEmailMutation(props: UseAthleteSendEmailMutationProps) {
  const queryKey = ["AthleteService.sendInvite", props.athleteId];

  return useMutation<{ id: string }, Error, typeof queryKey, AthleteSendEmailArg>(queryKey, async (_, { arg }) =>
    AthleteService.sendInvite(arg.athleteId)
  );
}

export default useAthleteSendEmailMutation;
